import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
// import { crearCategoria, modificarCategoria } from "../../../api/api-categoria";
// import cargandoCard from "../../../components/cargando-card";
// import { obtenerListaCategoria } from "../../../api/api-categoria";
import Select from "react-select";
// import { actualizarProducto, crearProducto } from "../../../api/api-producto";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { useToast, useProcessing } from "../../../context/ui-feedback-context";
import { actualizarSolicitudProducto, crearSolicitudProducto } from "../../../api/api-solicitud-producto";
import SendRequestComponent from "../../../components/btn-request";
import { obtenerListaProducto } from "../../../api/api-producto";
import { obtenerListaPais } from "../../../api/api-pais";
import { obtenerListaCiudadPorPais } from "../../../api/api-ciudad";
import { obtenerListaPrioridadEntrega } from "../../../api/api-prioridad-entrega";
import { Plus } from "lucide-react";
import { COLOR_VERDE_MAIN } from "../../../utils/const/colors-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import ModalRequerimientoProducto from "../../../components/modal-requerimiento-producto";
import { sharedMensajeConfirmacion } from "../../../utils/shared-functions";

let $ = window.$;

export default function SolicitudProductoPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  // const [listaCategoria, setListaCategoria] = useState([]);
  // const [categoriaSelected, setCategoriaSelected] = useState(null);
  // Toast only (success / error messages)
  const { showToast } = useToast();
  // Processing overlay only (loading while API runs)
  const { showProcessing, hideProcessing } = useProcessing();

  const [sendRequest, setSendRequest] = useState(false);

  const [listaProducto, setListaProducto] = useState([]);
  // const [productoSelected, setProductoSelected] = useState(null);
  // const [listaPais, setListaPais] = useState([]);
  // const [paisSelected, setPaisSelected] = useState(null);
  // const [listaCiudad, setListaCiudad] = useState([]);
  // const [ciudadSelected, setCiudadSelected] = useState(null);
  const [listaPrioridad, setListaPrioridad] = useState([]);
  const [prioridadSelected, setPrioridadSelected] = useState(null);

  const [rowsData, setRowsData] = useState([]);

  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [modalRequerimientoProductoVisible, setModalRequerimientoProductoVisible] = useState(false);
  const [productoEditar, setProductoEditar] = useState(null);
  const [elementoSelected, setElementoSelected] = useState(null);

  const charLimits = {
    codigo: 128,
    descripcion: 256,
    nota: 512,
  };

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }

      const [productos, prioridades] = await Promise.all([
        obtenerListaProducto({ habilitado: 1 }, true),
        obtenerListaPrioridadEntrega({ habilitado: 1 }, true),
      ]);

      setListaProducto(productos);

      setListaPrioridad(prioridades);
      if (data.params.idPrioridad !== undefined && data.params.idPrioridad !== null) {
        const prioridad = prioridades.find((item) => item.value === data.params.idPrioridad);
        setPrioridadSelected(prioridad);
      }

      if (Array.isArray(data.params.rowsData) && data.params.rowsData.length > 0) {
        setRowsData(data.params.rowsData);
      } else {
        setRowsData([]);
      }

    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  };

  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainer");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            // Grid already exists, just update the data source
            gridInstance.option("dataSource", rowsData);
          } else {
            // Grid doesn't exist yet, initialize it
            inicializarGrid();
          }
        } catch (e) {
          // Grid doesn't exist yet, initialize it
          inicializarGrid();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsData]);

  const inicializarGrid = () => {
    try {
      const gridElement = $("#gridContainer");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsData,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        wordWrapEnabled: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 200,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
              // console.log("cellTemplate acciones");
              // console.log('options', options);
              // console.log('options.data', options.data);
              const buttonContainer = $("<div>").addClass("flex gap-2");
              // if (btnModificar === true) {
              // Edit button
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                )
                .text(t("column_modificar"))
                .on("click", function () {
                  modificarElementoSelected(options.data);
                })
                .appendTo(buttonContainer);
              // }

              // if (btnDeshabilitar === true) {
              // Delete button
              if (options.data.habilitado === 1) {
                $("<button>")
                  .addClass(
                    "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                  )
                  .text(t("column_deshabilitar"))
                  .on("click", function () {
                    cambiarEstadoDeshabilitar(options.data);
                  })
                  .appendTo(buttonContainer);
              }
              // }
              // if (btnHabilitar === true) {
              if (options.data.habilitado === 0) {
                $("<button>")
                  .addClass(
                    `px-3 py-1 bg-[${COLOR_VERDE_MAIN}] hover:bg-[#006600] text-white rounded text-sm`
                  )
                  .text(t("column_habilitar"))
                  .on("click", function () {
                    cambiarEstadoHabilitar(options.data);
                  })
                  .appendTo(buttonContainer);
              }
              // }

              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "idProducto",
            caption: t("column_id_producto"),
            visible: false,
          },
          {
            dataField: "producto",
            caption: t("column_producto"),
            visible: true,
            width: 200,
          },
          {
            dataField: "cantidad",
            caption: t("column_cantidad"),
            visible: true,
          },
          {
            dataField: "fechaProceso",
            caption: t("column_fechaProceso"),
            width: 200,
          },
          {
            dataField: "habilitadoLabel",
            caption: t("column_estado"),
            width: 200,
          }
        ],
      });
    } catch (err) {
      console.error("Error initializing grid:", err);
    }
  };

  const modificarElementoSelected = (data) => {
    try {
      setProductoEditar(data);
      setModalRequerimientoProductoVisible(true);
    } catch (err) {
      console.log("modificarElementoSelected err");
      console.log(err);
    }
  };

  const cambiarEstadoDeshabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoDeshabilitar");
      // console.log(data);
      // console.log(data.id);
      // console.log(data.id < 0);
      if (data.id < 0) {
        setRowsData((prev) => prev.filter((item) => item.id !== data.id));
      } else {
        setRowsData((prev) => prev.map((item) => item.id === data.id ? { ...item, habilitado: 0, habilitadoLabel: t("column_deshabilitado") } : item));
      }
      // setElementoSelected(data);
      // setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoDeshabilitar err");
      console.log(err);
    }
  };

  const cambiarEstadoHabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoHabilitar");
      // console.log(data);
      setRowsData((prev) => prev.map((item) => item.id === data.id ? { ...item, habilitado: 1, habilitadoLabel: t("column_habilitado") } : item));
      // setElementoSelected(data);
      // setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoHabilitar err");
      console.log(err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let filteredValue = value;

    // Only allow digits 0-9 for grupo field
    if (name === "grupo") {
      filteredValue = value.replace(/[^0-9]/g, "");
    }

    if (filteredValue.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: filteredValue,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      // if (prioridadSelected === null) {
      //   message = message + t("alert_debe_seleccionar_prioridad") + '\n';
      // }
      if (formData.descripcion === undefined || formData.descripcion === null || String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (rowsData.length === 0) {
        message = message + t("alert_debe_ingresar_al_menos_un_producto") + '\n';
      }
      if (message.length > 0) {
        showToast(message, 'error');
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.rowsData = rowsData;
    objEnviar.idPrioridad = prioridadSelected !== null ? prioridadSelected.value : null;
    showProcessing();
    setSendRequest(true);
    if (formData.id === 0) {
      // console.log('crear correo');
      const response = await crearSolicitudProducto(objEnviar);
      hideProcessing();
      setSendRequest(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_creo_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_crear"));
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const response = await actualizarSolicitudProducto(objEnviar);
      hideProcessing();
      setSendRequest(false);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        showToast(t("alert_se_modifico_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_modificar"));
      }
    }
  };

  // const handleConfirmModalDeshabilitar = async () => {
  //   setModalConfirmarDeshabilitarVisible(false);
  //   if (elementoSelected == null) {
  //     return;
  //   }
  // };

  // const handleConfirmHabilitarModal = async () => {
  //   setModalConfirmarHabilitarVisible(false);
  //   if (elementoSelected == null) {
  //     return;
  //   }
  // };

  const handleAgregarProductoClick = () => {
    setProductoEditar(null);
    setModalRequerimientoProductoVisible(true);
  };

  const agregarProducto = ({ id, productSelected, cantidad, isEdit }) => {
    const idProducto = productSelected?.value ?? null;
    const alreadyExists = rowsData.some(
      (item) =>
        String(item.idProducto) === String(idProducto) &&
        String(item.id) !== String(id)
    );
    if (alreadyExists) {
      showToast(t("alert_producto_ya_agregado"), "warning", 3000);
      return;
    }

    if (isEdit) {
      setRowsData((prev) =>
        prev.map((item) =>
          String(item.id) === String(id)
            ? {
              ...item,
              idProducto,
              producto: productSelected?.label ?? "",
              cantidad,
            }
            : item
        )
      );
    } else {
      const nuevoProducto = {
        id,
        idProducto,
        producto: productSelected?.label ?? "",
        cantidad,
        habilitado: 1,
        habilitadoLabel: t("column_habilitado"),
      };
      setRowsData((prev) => [...prev, nuevoProducto]);
    }

    setProductoEditar(null);
    setModalRequerimientoProductoVisible(false);
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={formData?.codigo ?? ''}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{String(formData?.codigo).trim().length ?? 0}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="descripcion"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  // inputMode="numeric"
                  // pattern="[0-9]*"
                  value={formData?.descripcion ?? ''}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{String(formData?.descripcion).trim().length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData?.nota ?? ''}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{String(formData?.nota).trim().length}/{charLimits.nota}</p>
              </div>
              {/* <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="producto">
                  {t("label_producto")}<span className="text-red-500">*</span>
                </label>
                <Select options={listaProducto}
                  isSearchable={true}
                  isClearable={true}
                  value={productoSelected}
                  onChange={(event) => setProductoSelected(event)}
                  placeholder={t("placeholder_seleccione_producto")}
                />
              </div> */}
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="prioridad">
                  {t("label_prioridad")}
                </label>
                <Select options={listaPrioridad}
                  isSearchable={true}
                  isClearable={true}
                  value={prioridadSelected}
                  onChange={(event) => setPrioridadSelected(event)}
                  placeholder={t("placeholder_seleccione_prioridad")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4"></div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4 flex justify-end items-end">
                <button
                  type="button"
                  className={`${ESTILO_BOTON_GENERAL_ACEPTAR} group items-center gap-2 transition-all duration-200 ease-out hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 active:scale-95`}
                  onClick={handleAgregarProductoClick}
                >
                  <Plus className="h-4 w-4 transition-transform duration-200 group-hover:scale-125 group-hover:rotate-90" />
                  {t("label_agregar_producto")}
                </button>
              </div>
            </div>
            <br />
            {/* Grid Card */}
            <div className="bg-white border border-gray-200 rounded-lg p-2">
              <div className="min-h-[400px]">
                <div
                  id="gridContainer"
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    {t("label_cancelar")}
                  </button>
                  <SendRequestComponent
                    loading={sendRequest}
                    label={t("label_guardar")}
                    onClick={handleSaveClick}
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                  />
                </div>
              </div>
            </div>
            {/* <ModalConfirmar
              isOpen={modalConfirmarDeshabilitarVisible}
              onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
              onConfirm={handleConfirmModalDeshabilitar}
              message={sharedMensajeConfirmacion(t("alert_esta_de_deshabilitar"), elementoSelected?.producto)}
            />
            <ModalConfirmar
              isOpen={modalConfirmarHabilitarVisible}
              onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
              onConfirm={handleConfirmHabilitarModal}
              message={sharedMensajeConfirmacion(t("alert_esta_de_habilitar"), elementoSelected?.producto)}
            /> */}
            <ModalRequerimientoProducto
              isOpen={modalRequerimientoProductoVisible}
              listaProductos={listaProducto}
              rowsDataLength={rowsData.length}
              productoEditar={productoEditar}
              onCancel={() => {
                setProductoEditar(null);
                setModalRequerimientoProductoVisible(false);
              }}
              onAceptar={agregarProducto}
            />
          </div>

        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
